module.exports = __webpack_public_path__ + "img/library-memoriam.5c2a0a8b.jpg";